module.exports = __webpack_public_path__ + "img/fecha2.f46168c8.png";